module.exports = __webpack_public_path__ + "static/media/Lednice.76a96904.jpg";